import React, { useState } from 'react';
import axios from 'axios';
import './Page4.css';

function Page4() {
  const [inputText, setInputText] = useState('');
  const [selectedDevice, setSelectedDevice] = useState('Downstairs speaker');
  const [isLoading, setIsLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');

  const castToDevice = async () => {
    if (!inputText.trim()) {
      setResponseMessage('Please enter text to cast.');
      return;
    }

    setIsLoading(true);
    setResponseMessage('');

    try {
      const response = await axios.post(
        'https://kidr78home.duckdns.org/api/casttext',
        {
          device: selectedDevice,
          text: inputText,
        },
        {
          headers: {
            Authorization: 'kSuIlUmNaTiIeO5',
          },
        }
      );
      setResponseMessage(response.data.message || 'Text successfully sent!');
      setInputText(''); // Clear text after successful cast
    } catch (error) {
      console.error('Error casting text:', error);
      setResponseMessage('Failed to cast text. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && e.ctrlKey) {
      castToDevice();
    }
  };

  const clearText = () => {
    setInputText('');
    setResponseMessage('');
  };

  return (
    <div className="cast-container">
      <div className="cast-header">
        <h1 className="cast-title">📱 Text to Speech</h1>
        <p className="cast-subtitle">Cast your message to smart speakers</p>
      </div>

      <div className="cast-form">
        {/* Device Selection */}
        <div className="device-selection-section">
          <h3 className="section-title">🔊 Select Device</h3>
          <div className="device-grid">
            {['Downstairs speaker', 'bedroom speaker', 'Valery Studio'].map((device) => (
              <button
                key={device}
                className={`device-card ${selectedDevice === device ? 'selected' : ''}`}
                onClick={() => setSelectedDevice(device)}
              >
                <div className="device-icon">
                  {device.includes('bedroom') ? '🛏️' : 
                   device.includes('Studio') ? '🎨' : '🏠'}
                </div>
                <span className="device-name">{device}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Text Input */}
        <div className="text-input-section">
          <h3 className="section-title">✍️ Your Message</h3>
          <div className="text-input-container">
            <textarea
              className="text-input"
              rows="6"
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Type your message here... (Ctrl+Enter to send)"
            />
            <div className="text-input-footer">
              <span className="char-count">{inputText.length} characters</span>
              {inputText && (
                <button className="clear-button" onClick={clearText}>
                  Clear
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="action-section">
          <button
            className={`cast-button ${isLoading ? 'loading' : ''}`}
            onClick={castToDevice}
            disabled={isLoading || !inputText.trim()}
          >
            {isLoading ? (
              <>
                <span className="loading-spinner"></span>
                Casting...
              </>
            ) : (
              <>
                <span className="cast-icon">📢</span>
                Cast to {selectedDevice}
              </>
            )}
          </button>
        </div>

        {/* Quick Messages */}
        <div className="quick-messages-section">
          <h3 className="section-title">⚡ Quick Messages</h3>
          <div className="quick-messages-grid">
            {[
              'Dinner is ready!',
              'Meeting starting in 5 minutes',
              'Please come downstairs',
              'Time for bed',
              'Good morning everyone!',
              'Don\'t forget your keys'
            ].map((message) => (
              <button
                key={message}
                className="quick-message-button"
                onClick={() => setInputText(message)}
              >
                {message}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Response Message */}
      {responseMessage && (
        <div className={`response-section ${responseMessage.includes('Failed') || responseMessage.includes('Please') ? 'error' : 'success'}`}>
          <div className="response-card">
            <span className="response-icon">
              {responseMessage.includes('Failed') || responseMessage.includes('Please') ? '❌' : '✅'}
            </span>
            <p className="response-text">{responseMessage}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Page4;

